module.exports = __webpack_public_path__ + "img/04.a14e4038.jpg";